app.service('userPrefService', ['crudService', function (crudService) {
	function getRouteName(group, name) {
		return '/user_preference/'+group+'/'+name;
	}

	return {
		get: function(group, name) {
			return crudService.get(getRouteName(group, name));
		},
		set: function (group, name, value) {
			return crudService.post(getRouteName(group, name), {'value' : value});
		}
	}
}]);